const _GUEST_ROUTE_NAME = Object.freeze({} as const);

const _PRIVATE_ROUTE_NAME = Object.freeze({
  HOME: "home",
  VERIFICATION: "verification",
  VERIFICATION_APPLY: "verification-apply",
  VERIFICATION_THANKS: "verification-thanks",
  USER_REACTIVATION: "user-reactivation",
  LADY_REACTIVATION: "lady-reactivation",
  USER_FORBIDDEN: "user-forbidden",
  LADY_FORBIDDEN: "lady-forbidden",
  USER_ENTRY: "user-entry",
  LADY_ENTRY: "lady-entry",
  INIT: "init",
  INIT_THANKS: "init-thanks",
  ACCOUNT: "account",
  ACCOUNT_PHONE: "account-phone",
  ACCOUNT_EMAIL: "account-email",
  ACCOUNT_PRIVATE: "account-private",
  ACCOUNT_HIDDEN_ROOMS: "account-hidden-rooms",
  ACCOUNT_OFFER: "account-offer",
  NOTIFY: "notify",
  SETTING: "setting",
  SETTING_DETAIL: "setting-detail",
  POINT_HISTORY: "point-history",
  POINT_CREATE: "point-create",
  RECEIPT_ISSUE: "receipt-issue",
  CHAT: "chat",
  CHAT_DETAIL: "chat-detail",
  CHAT_TEMPLATE_NEW: "chat-template-new",
  CHAT_TEMPLATE_EDIT: "chat-template-edit",
  MEMBER: "member",
  MEMBER_DETAIL: "member-detail",
  MEMBER_SEARCH: "member-search",
  HELP: "help",
  OFFER_DETAIL_CREATE: "offer-detail-create",
  FAVORITE: "favorite",
  FAVORITE_SEARCH: "favorite-search",
  NOTICE: "notice",
  NOTICE_DETAIL: "notice-detail",
  PROFILE: "profile",
  PLAN_SUBSCRIBE: "plan-subscribe",
  PLAN_SUBSCRIBE_CHECKOUT: "plan-subscribe-checkout",
  PLAN_SUBSCRIBE_COMPLETE: "plan-subscribe-complete",
  PLAN_CANCEL: "plan-cancel",
  PLAN_CANCEL_CONFIRM: "plan-cancel-confirm",
  PLAN_CANCEL_COMPLETE: "plan-cancel-complete",
  PLAN_RESUME: "plan-resume",
  PLAN_RESUME_CONFIRM: "plan-resume-confirm",
  PLAN_RESUME_COMPLETE: "plan-resume-complete",
  QUIZ: "quiz",
  RESERVE_INTERVIEW: "reserve-interview",
  METHOD_SELECT: "method-select",
  ENTRY: "entry",
} as const);

export const ROUTE_NAME = Object.freeze({
  ..._GUEST_ROUTE_NAME,
  ..._PRIVATE_ROUTE_NAME,
} as const);
